import React, { useState, useRef } from 'react';
import './CollegeStudent.css';
import SpecialisedForm from '../SpecialisedForm/SpecialisedForm';
import InternshipDetail from '../InternshipDetail/InternshipDetail';

function CollegeStudent({ onClose, onMoreDetails, onCloseTraining }) {
  const [showSpecialised, setShowSpecialised] = useState(false);
  const [showInternship, setShowInternship] = useState(false);
  const internshipRef = useRef(null);

  return (
    <div className="cs__wrapper">
      <div className="cs__inner">

        <button className="cs__close" onClick={onClose}>✕</button>

        <h2 className="cs__title">College Student Training</h2>
        <p className="cs__subtitle">
          A flexible program for college students at iBots centres, offering
          weekend batches, internships, and advanced specializations. Focused
          on hands-on, industry-oriented learning through practical projects
          and real-world applications.
        </p>

        <div className="cs__badges">
          {[
            { text: 'Ratio: 5:1' },
            { text: 'Mode: Hybrid / Offline' },
            { text: 'Certificates Provided' },
            { text: 'All ibots Centres' },
          ].map((b, i) => (
            <span key={i} className="cs__badge">
              <span>{b.icon}</span> {b.text}
            </span>
          ))}
        </div>

        <div className="cs__policy">
          <span className="cs__policy-icon">🔧</span>
          <div>
            <strong>KIT POLICY — PLEASE NOTE</strong>
            <p>
              All kits used during training sessions are available for use at
              the ibots centre and{' '}
              <strong>must be returned at the end of each session</strong>. If
              you wish to take a kit home for further practice,{' '}
              <strong>additional kit charges apply</strong> based on the tools
              and components included in that specific kit.{' '}
              <a href="#" className="cs__policy-link">
                View all DIY Kits on ibots.in →
              </a>
            </p>
          </div>
        </div>

        <div className="cs__cards">

          {/* Card 1 — Regular Training */}
          <div className="cs__card">
            <div className="cs__card-header">
              <span className="cs__card-tag">REGULAR TRAINING</span>
              <span className="cs__card-badge cs__card-badge--outline">Weekend Regular</span>
            </div>
            <div className="cs__card-body">
              <h3 className="cs__card-title">Hands on Training</h3>
              <div className="cs__card-tags">
                {['4 months', '32 hrs', '2 hrs/session', 'Weekends'].map((t, i) => (
                  <span key={i} className="cs__tag">{t}</span>
                ))}
              </div>
              <ul className="cs__card-points">
                <li>A weekend-based hands-on training program for college students</li>
                <li>Covers Electronics, Embedded Systems, IoT, Robotics, AI, Drone Technology, and multiple other technical courses</li>
                <li>Focused on practical, project-based learning and skill development</li>
              </ul>
              <button
                className="cs__card-btn"
                onClick={() => {
                  setShowInternship(false);
                  setShowSpecialised(false);
                  onMoreDetails && onMoreDetails('college');
                }}
              >
                More Details
              </button>
            </div>
          </div>

          {/* Card 2 — Specialised Programme */}
          <div className="cs__card">
            <div className="cs__card-header">
              <span className="cs__card-tag">SPECIALISED PROGRAMME</span>
              <span className="cs__card-badge cs__card-badge--outline">AI + Vision</span>
            </div>
            <div className="cs__card-body">
              <div className="cs__card-title-row">
                <h3 className="cs__card-title">Specialised Course</h3>
                <span className="cs__custom-badge">Custom</span>
              </div>
              <div className="cs__card-tags">
                {['15 days', '30 hrs', 'Raspberry Pi', 'Camera Module', 'AI + Vision'].map((t, i) => (
                  <span key={i} className="cs__tag">{t}</span>
                ))}
              </div>
              <ul className="cs__card-points">
                <li>A flexible, customized training program designed based on student interests and requirements</li>
                <li>Offers hands-on, project-based learning with personalized guidance</li>
                <li>Helps students build practical skills in their chosen areas</li>
              </ul>
              <button
                className="cs__card-btn"
                onClick={() => {
                  onCloseTraining && onCloseTraining();
                  setShowInternship(false);
                  setShowSpecialised(true);
                }}
              >
                More Details
              </button>
            </div>
          </div>

          {/* Card 3 — Internship */}
          <div className="cs__card">
            <div className="cs__card-header">
              <span className="cs__card-tag">INTERNSHIP PROGRAMME</span>
              <span className="cs__card-badge cs__card-badge--outline">Semester Break</span>
            </div>
            <div className="cs__card-body">
              <h3 className="cs__card-title">Internship at ibots</h3>
              <div className="cs__internship-cards">
                <div className="cs__internship-card">
                  <p className="cs__internship-type">TRAINING INTERNSHIP</p>
                  <p className="cs__internship-title">Training Internship</p>
                  <p className="cs__internship-desc">
                    A structured internship with guided, hands-on training in
                    industry-relevant skills. Participants receive a certificate
                    along with an internship experience letter.
                  </p>
                </div>
                <div className="cs__internship-card cs__internship-card--stipend">
                  <p className="cs__internship-type cs__internship-type--stipend">PROFESSIONAL INTERNSHIP</p>
                  <p className="cs__internship-title cs__internship-title--stipend">Professional Internship</p>
                  <p className="cs__internship-desc">
                    A selective internship where chosen candidates work with
                    the iBots engineering team on live projects and product
                    development. Interns gain real industry experience and
                    receive a stipend during the program.
                  </p>
                </div>
              </div>
              <ul className="cs__card-points">
                <li>Two distinct internship tracks</li>
                <li>Training Internship: structured, guided hands-on training with certification and experience letter</li>
                <li>Professional Internship: selective placement with the iBots engineering team on live projects, with stipend provided</li>
              </ul>
              <button
                className="cs__card-btn"
                onClick={() => {
                  onCloseTraining && onCloseTraining();
                  setShowSpecialised(false);
                  setShowInternship(true);
                  setTimeout(() => {
                    internshipRef.current?.scrollIntoView({ behavior: 'smooth' });
                  }, 100);
                }}
              >
                More Details
              </button>
            </div>
          </div>

        </div>
      </div>

      {showSpecialised && (
        <SpecialisedForm onClose={() => setShowSpecialised(false)} />
      )}

      <div ref={internshipRef}>
        {showInternship && (
          <InternshipDetail onClose={() => setShowInternship(false)} />
        )}
      </div>

    </div>
  );
}

export default CollegeStudent;
